// import React, { useEffect, useState } from "react";
// import MovieServices from "../../services/externalServices/TicketServices/moviesServices";
// import TheatreServices from "../../services/externalServices/TicketServices/theatreServices";
// import PurchaseCostServices from "../../services/externalServices/TicketServices/purchaseCostServices"



// const PurchaseCost = () => {
//     const [costs, setCosts] = useState([]);
//     const [form, setForm] = useState({ movieId: "", cost: "" });
//     const [editing, setEditing] = useState(null);
//     const [theatres, setTheatres] = useState([]);
//     const [movies, setMovies] = useState([]);
//     const [selectedTheatre, setSelectedTheatre] = useState("");
//     const [selectedTheatreId, setSelectedTheatreId] = useState("");


//     const { role = "", accessList = [] } = JSON.parse(localStorage.getItem("admin") || "{}");
//     const isTicketAdmin = role === "ticket-admin";
//     const theatreName = isTicketAdmin ? accessList?.[0] : "";





//     useEffect(() => {
//         const fetchData = async () => {
//             try {
//                 const allTheatres = await TheatreServices.getTheatres();
//                 const filtered = isTicketAdmin
//                     ? allTheatres.filter((t) => accessList.includes(t.name))
//                     : allTheatres;

//                 setTheatres(filtered);
//                 const defaultTheatre = filtered[0]?._id;


//                 console.log('filtered', filtered)
//                 // setSelectedTheatre(defaultTheatre);

//                 setSelectedTheatre(filtered[0]?.name);
//                 setSelectedTheatreId(defaultTheatre);

//                 // Fetch movies and make sure it's an array
//                 // const movieList = await MovieServices.getMovies(defaultTheatre);
//                 // console.log("Movie list:", movieList); // 👈 Check this

//                 const movieList = await MovieServices.getMovies(selectedTheatre);

//                 console.log('MovieList', movieList)
//                 setMovies(movieList);

//                 if (Array.isArray(movieList)) {
//                     setMovies(movieList);
//                 } else {
//                     setMovies([]);
//                     console.error("MovieServices.getMovies() did not return an array");
//                 }
//             } catch (err) {
//                 console.error("Error loading data", err);
//             }
//         };
//         fetchData();
//     }, []);



//     useEffect(() => {
//         if (selectedTheatreId) {
//             console.log("Fetching costs for theatre:", selectedTheatreId); // Debugging
//             fetchCosts();
//         }
//     }, [selectedTheatreId]);  // Ensure you're using selectedTheatreId here


//     const fetchCosts = async () => {
//         try {
//             console.log("Fetching costs for theatre:", selectedTheatreId, selectedTheatre);
//             const res = await PurchaseCostServices.getPurchaseCostsByTheatre(selectedTheatreId);
//             console.log("Fetched costs:", res.data);
//             setCosts(res.data || []);
//         } catch (err) {
//             console.error("Error fetching costs", err);
//         }
//     };


//     const handleChange = (e) => {
//         setForm({ ...form, [e.target.name]: e.target.value });
//     };



//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         try {
//             if (!form.movieId || !form.cost) return;

//             const payload = {
//                 movieId: form.movieId,
//                 theatreId: selectedTheatre,
//                 cost: form.cost,
//             };

//             let response;
//             if (editing) {
//                 response = await PurchaseCostServices.updatePurchaseCost(
//                     editing?.movieId,
//                     editing?.theatreId,
//                     { cost: form.cost }
//                 );
//             } else {
//                 response = await PurchaseCostServices.createPurchaseCost(payload);
//             }

//             console.log("Submit response:", response);

//             //   setForm({ movieId: "", cost: "" });
//             //   setEditing(null);
//             //   fetchCosts();


//             if (response?.error) {
//                 alert(`⚠️ ${response.error}`);
//             } else {
//                 alert("✅ Submitted successfully!");
//                 setForm({ movieId: "", cost: "" });
//                 setEditing(null);
//                 fetchCosts();
//             }
//         } catch (err) {
//             console.error("Submit error:", err);
//             alert("❌ Submission failed. Please try again.");
//         }
//     };




//     const handleEdit = (movieId, movieName, theatreId,theatreName, cost) => {
//         console.log('In the handle edit &&&&&&&&&&&&&&', movieId, movieName,theatreId,theatreName, cost);
//         setForm({ movieId, movieName, theatreId,theatreName,cost });  // Pass movieName for frontend display
//         setEditing({ movieId, movieName,theatreId, theatreName,cost });
//     };


//     const handleDelete = async (movie, theatre) => {
//         console.log('in the delete handle',movie, theatre);
//         try {
//             await PurchaseCostServices.deletePurchaseCost(movie, theatre);
//             fetchCosts();
//         } catch (err) {
//             console.error("Delete error:", err);
//         }
//     };

//     return (
//         <div style={{ padding: 20 }}>
//             <h2>🎫 Purchase Cost Management</h2>

//             <div style={{ marginBottom: 20 }}>
//                 <label><strong>Select Theatre:</strong> </label>



//                 <select
//                     value={selectedTheatre}
//                     onChange={(e) => {
//                         const selected = theatres.find(t => t.name === e.target.value);
//                         setSelectedTheatre(selected.name);
//                         setSelectedTheatreId(selected._id);
//                         console.log("Selected Theatre ID:", selected._id); // Debugging
//                         setForm({ movieId: "", cost: "" });
//                         setEditing(null);
//                     }}
//                 >
//                     {theatres.map((t) => (
//                         <option key={t._id} value={t.name}>{t.name}</option>
//                     ))}
//                 </select>
//             </div>

//             <form onSubmit={handleSubmit} style={{ marginBottom: 30 }}>
//                 <label><strong>Movie:</strong> </label>
//                 <select
//                     name="movieId"
//                     value={form.movieId}
//                     onChange={handleChange}
//                     disabled={!!editing}
//                     required
//                 >
//                     <option value="">-- Select Movie --</option>
//                     {movies.map((movie) => (
//                         <option key={movie._id} value={movie._id}>{movie.name}</option>
//                     ))}
//                 </select>

//                 <label style={{ marginLeft: 20 }}><strong>Cost:</strong> </label>
//                 <input
//                     type="number"
//                     name="cost"
//                     value={form.cost}
//                     onChange={handleChange}
//                     required
//                 />

//                 <button type="submit" style={{ marginLeft: 20 }}>
//                     {editing ? "Update" : "Add"}
//                 </button>

//                 {editing && (
//                     <button
//                         type="button"
//                         onClick={() => {
//                             setEditing(null);
//                             setForm({ movieId: "", cost: "" });
//                         }}
//                         style={{ marginLeft: 10 }}
//                     >
//                         Cancel
//                     </button>
//                 )}
//             </form>

//             <h3>📃 Purchase Cost Report</h3>
//             <table border="1" cellPadding="8" style={{ width: "100%", textAlign: "left" }}>
//                 <thead>
//                     <tr>
//                         <th>Theatre</th>
//                         <th>🎬 Movie Name</th>
//                         <th>💰 Cost</th>
//                         <th>⚙️ Actions</th>
//                     </tr>
//                 </thead>
//                 <tbody>
//                     {costs.length > 0 ? (
//                         costs.map(({ movieId,theatreId,cost }) => {
//                             console.log(' movieId, cost', movieId._id, cost)
//                             // const movie = movies.find((m) => m._id === movieId);
//                             // console.log('movie',movie);
//                             const movie = movieId?._id;
//                             const movieName = movieId?.name;
//                             const theatre = theatreId?._id;
//                             const theatreName = theatreId?.name;
//                             // Ensure movie is defined and name is a valid string
//                             // const movieName = movie?.name || "Unknown Movie";

//                             return (
//                                 <tr key={movieId}>
//                                     {/* <td>{movie?.name || movieId}</td> */}
//                                     <td>{theatreId?.name}</td>
//                                     <td>{movieName}</td> {/* Ensure movieName is a string */}
//                                     <td>{cost}</td>
//                                     <td>
//                                     <button onClick={() => handleEdit(movieId._id, movieName,theatreId?._id,theatreId?.name, cost)}>Edit</button>
//                                         {/* <button onClick={() => handleEdit(movieName, cost)}>Edit</button> */}
//                                         <button onClick={() => handleDelete(movie,theatre)} style={{ marginLeft: 10 }}>
//                                             Delete
//                                         </button>
//                                     </td>
//                                 </tr>
//                             );
//                         })
//                     ) : (
//                         <tr>
//                             <td colSpan="3">No purchase costs found for this theatre.</td>
//                         </tr>
//                     )}
//                 </tbody>
//             </table>
//         </div>
//     );
// };

// export default PurchaseCost;









import React, { useEffect, useState } from "react";
import MovieServices from "../../services/externalServices/TicketServices/moviesServices";
import TheatreServices from "../../services/externalServices/TicketServices/theatreServices";
import PurchaseCostServices from "../../services/externalServices/TicketServices/purchaseCostServices"
// import { FiSettings, FiCalendar, FiFilm, FiHome, FiCheckSquare, FiDollarSign } from 'react-icons/fi';
import { FiPlus, FiEdit, FiFilePlus } from 'react-icons/fi';


// const PurchaseCost = () => {
//     const [costs, setCosts] = useState([]);
//     const [form, setForm] = useState({ movieId: "", cost: "" });
//     const [editing, setEditing] = useState(null);
//     const [theatres, setTheatres] = useState([]);
//     const [movies, setMovies] = useState([]);
//     const [selectedTheatre, setSelectedTheatre] = useState("");
//     const [selectedTheatreId, setSelectedTheatreId] = useState("");

//     const { role = "", accessList = [] } = JSON.parse(localStorage.getItem("admin") || "{}");
//     const isTicketAdmin = role === "ticket-admin";
//     const theatreName = isTicketAdmin ? accessList?.[0] : "";

//     useEffect(() => {
//         const fetchData = async () => {
//             try {
//                 const allTheatres = await TheatreServices.getTheatres();
//                 const filtered = isTicketAdmin
//                     ? allTheatres.filter((t) => accessList.includes(t.name))
//                     : allTheatres;

//                 setTheatres(filtered);
//                 const defaultTheatre = filtered[0]?._id;
//                 setSelectedTheatre(filtered[0]?.name);
//                 setSelectedTheatreId(defaultTheatre);

//                 const movieList = await MovieServices.getMovies(selectedTheatre);
//                 setMovies(movieList);

//                 if (Array.isArray(movieList)) {
//                     setMovies(movieList);
//                 } else {
//                     setMovies([]);
//                     console.error("MovieServices.getMovies() did not return an array");
//                 }
//             } catch (err) {
//                 console.error("Error loading data", err);
//             }
//         };
//         fetchData();
//     }, []);

//     useEffect(() => {
//         if (selectedTheatreId) {
//             fetchCosts();
//         }
//     }, [selectedTheatreId]);

//     const fetchCosts = async () => {
//         try {
//             const res = await PurchaseCostServices.getPurchaseCostsByTheatre(selectedTheatreId);
//             setCosts(res.data || []);
//         } catch (err) {
//             console.error("Error fetching costs", err);
//         }
//     };

//     const handleChange = (e) => {
//         setForm({ ...form, [e.target.name]: e.target.value });
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         try {
//             if (!form.movieId || !form.cost) return;

//             const payload = {
//                 movieId: form.movieId,
//                 theatreId: selectedTheatreId,
//                 cost: form.cost,
//             };

//             let response;
//             if (editing) {
//                 response = await PurchaseCostServices.updatePurchaseCost(
//                     editing?.movieId,
//                     editing?.theatreId,
//                     { cost: form.cost }
//                 );
//             } else {
//                 response = await PurchaseCostServices.createPurchaseCost(payload);
//             }

//             if (response?.error) {
//                 alert(`⚠️ ${response.error}`);
//             } else {
//                 alert("✅ Submitted successfully!");
//                 setForm({ movieId: "", cost: "" });
//                 setEditing(null);
//                 fetchCosts();
//             }
//         } catch (err) {
//             console.error("Submit error:", err);
//             alert("❌ Submission failed. Please try again.");
//         }
//     };

//     const handleEdit = (movieId, movieName, theatreId, theatreName, cost) => {
//         setForm({ movieId, movieName, theatreId, theatreName, cost });
//         setEditing({ movieId, movieName, theatreId, theatreName, cost });
//     };

//     const handleDelete = async (movieId, theatreId) => {
//         console.log('in delete', movieId, theatreId)
//         try {
//             await PurchaseCostServices.deletePurchaseCost(movieId, theatreId);
//             fetchCosts();
//         } catch (err) {
//             console.error("Delete error:", err);
//         }
//     };

//     return (
//         <div className="p-6">
//             <h2 className="text-2xl font-semibold text-blue-600 mb-4">🎫 Purchase Cost Management</h2>

//             <div className="mb-4">
//                 <label className="font-semibold">Select Theatre: </label>
//                 <select
//                     value={selectedTheatre}
//                     onChange={(e) => {
//                         const selected = theatres.find(t => t.name === e.target.value);
//                         setSelectedTheatre(selected.name);
//                         setSelectedTheatreId(selected._id);
//                         setForm({ movieId: "", cost: "" });
//                         setEditing(null);
//                     }}
//                     className="ml-2 px-4 py-2 border rounded-md"
//                 >
//                     {theatres.map((t) => (
//                         <option key={t._id} value={t.name}>{t.name}</option>
//                     ))}
//                 </select>
//             </div>

//             <form onSubmit={handleSubmit} className="mb-6">
//                 <div className="flex space-x-4 mb-4">
//                     <div>
//                         <label className="font-semibold">Movie: </label>
//                         <select
//                             name="movieId"
//                             value={form.movieId}
//                             onChange={handleChange}
//                             disabled={!!editing}
//                             required
//                             className="ml-2 px-4 py-2 border rounded-md"
//                         >
//                             <option value="">-- Select Movie --</option>
//                             {movies.map((movie) => (
//                                 <option key={movie._id} value={movie._id}>{movie.name}</option>
//                             ))}
//                         </select>
//                     </div>
//                     <div>
//                         <label className="font-semibold">Cost: </label>
//                         <input
//                             type="number"
//                             name="cost"
//                             value={form.cost}
//                             onChange={handleChange}
//                             required
//                             className="ml-2 px-4 py-2 border rounded-md"
//                         />
//                     </div>
//                 </div>

//                 <button type="submit" className="px-6 py-2 bg-blue-500 text-white rounded-md">{editing ? "Update" : "Add"}</button>

//                 {editing && (
//                     <button
//                         type="button"
//                         onClick={() => {
//                             setEditing(null);
//                             setForm({ movieId: "", cost: "" });
//                         }}
//                         className="ml-4 px-6 py-2 bg-gray-500 text-white rounded-md"
//                     >
//                         Cancel
//                     </button>
//                 )}
//             </form>

//             <h3 className="text-xl font-semibold text-gray-700 mb-4">📃 Purchase Cost Report</h3>
//             <table className="min-w-full border-collapse table-auto border border-gray-300">
//                 <thead className="bg-gray-100">
//                     <tr>
//                         <th className="px-6 py-2 text-left font-semibold">Theatre</th>
//                         <th className="px-6 py-2 text-left font-semibold">🎬 Movie Name</th>
//                         <th className="px-6 py-2 text-left font-semibold">💰 Cost</th>
//                         <th className="px-6 py-2 text-left font-semibold">⚙️ Actions</th>
//                     </tr>
//                 </thead>
//                 <tbody>
//                     {costs.length > 0 ? (
//                         costs.map(({ movieId, theatreId, cost }) => {
//                             const movieName = movieId?.name;
//                             const theatreName = theatreId?.name;

//                             return (
//                                 <tr key={movieId}>
//                                     <td className="px-6 py-2">{theatreName}</td>
//                                     <td className="px-6 py-2">{movieName}</td>
//                                     <td className="px-6 py-2">{cost}</td>
//                                     <td className="px-6 py-2">
//                                         <button
//                                             onClick={() => handleEdit(movieId?._id, movieName, theatreId?._id, theatreName, cost)}
//                                             className="px-4 py-2 bg-yellow-500 text-white rounded-md"
//                                         >
//                                             Edit
//                                         </button>
//                                         <button
//                                             onClick={() => handleDelete(movieId?._id, theatreId?._id)}
//                                             className="ml-2 px-4 py-2 bg-red-500 text-white rounded-md"
//                                         >
//                                             Delete
//                                         </button>
//                                     </td>
//                                 </tr>
//                             );
//                         })
//                     ) : (
//                         <tr>
//                             <td colSpan="4" className="px-6 py-2 text-center">No purchase costs found for this theatre.</td>
//                         </tr>
//                     )}
//                 </tbody>
//             </table>
//         </div>
//     );
// };











// const PurchaseCost = () => {
//     const [form, setForm] = useState({ movieId: "", cost: "" });
//     const [editing, setEditing] = useState(null);
//     const [costs, setCosts] = useState([]);
//     const [theatres, setTheatres] = useState([]);
//     const [movies, setMovies] = useState([]);
//     const [selectedTheatre, setSelectedTheatre] = useState("");
//     const [selectedTheatreId, setSelectedTheatreId] = useState("");

//     const { role = "", accessList = [] } = JSON.parse(localStorage.getItem("admin") || "{}");
//     const isTicketAdmin = role === "ticket-admin";

//     const loadInitialData = async () => {
//         try {
//             const allTheatres = await TheatreServices.getTheatres();
//             const filteredTheatres = isTicketAdmin
//                 ? allTheatres.filter(t => accessList.includes(t.name))
//                 : allTheatres;

//             setTheatres(filteredTheatres);

//             if (filteredTheatres.length > 0) {
//                 const defaultTheatre = filteredTheatres[0];
//                 setSelectedTheatre(defaultTheatre.name);
//                 setSelectedTheatreId(defaultTheatre._id);
//                 loadMovies(defaultTheatre.name);
//             }
//         } catch (error) {
//             console.error("Error loading theatres:", error);
//         }
//     };

//     const loadMovies = async (theatreName) => {
//         try {
//             const movieList = await MovieServices.getMovies(theatreName);
//             setMovies(Array.isArray(movieList) ? movieList : []);
//         } catch (error) {
//             console.error("Error loading movies:", error);
//         }
//     };

//     const fetchCosts = async () => {
//         try {
//             const res = await PurchaseCostServices.getPurchaseCostsByTheatre(selectedTheatreId);
//             setCosts(res.data || []);
//         } catch (error) {
//             console.error("Error fetching costs:", error);
//         }
//     };

//     useEffect(() => {
//         loadInitialData();
//     }, []);

//     useEffect(() => {
//         if (selectedTheatreId) fetchCosts();
//     }, [selectedTheatreId]);

//     const handleChange = (e) => {
//         setForm({ ...form, [e.target.name]: e.target.value });
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         if (!form.movieId || !form.cost) return;

//         const payload = {
//             movieId: form.movieId,
//             theatreId: selectedTheatreId,
//             cost: form.cost,
//         };

//         try {
//             let response;
//             if (editing) {
//                 response = await PurchaseCostServices.updatePurchaseCost(
//                     editing.movieId,
//                     editing.theatreId,
//                     { cost: form.cost }
//                 );
//             } else {
//                 response = await PurchaseCostServices.createPurchaseCost(payload);
//             }

//             if (response?.error) {
//                 alert(`⚠️ ${response.error}`);
//             } else {
//                 alert("✅ Submitted successfully!");
//                 setForm({ movieId: "", cost: "" });
//                 setEditing(null);
//                 fetchCosts();
//             }
//         } catch (error) {
//             console.error("Submit error:", error);
//             alert("❌ Submission failed. Please try again.");
//         }
//     };

//     const handleEdit = (movieId, movieName, theatreId, theatreName, cost) => {
//         setForm({ movieId, cost });
//         setEditing({ movieId, movieName, theatreId, theatreName, cost });
//     };

//     const handleDelete = async (movieId, theatreId) => {
//         try {
//             await PurchaseCostServices.deletePurchaseCost(movieId, theatreId);
//             fetchCosts();
//         } catch (error) {
//             console.error("Delete error:", error);
//         }
//     };

//     return (
//         <div className="p-6">
//             <h2 className="text-2xl font-semibold text-blue-600 mb-6">🎫 Purchase Cost Management</h2>

//             {/* Theatre Selector */}
//             <div className="mb-6">
//                 <label className="font-semibold mr-2">Select Theatre:</label>
//                 <select
//                     value={selectedTheatre}
//                     onChange={(e) => {
//                         const selected = theatres.find(t => t.name === e.target.value);
//                         setSelectedTheatre(selected.name);
//                         setSelectedTheatreId(selected._id);
//                         loadMovies(selected.name);
//                         setForm({ movieId: "", cost: "" });
//                         setEditing(null);
//                     }}
//                     className="px-4 py-2 border rounded-md"
//                 >
//                     {theatres.map(t => (
//                         <option key={t._id} value={t.name}>{t.name}</option>
//                     ))}
//                 </select>
//             </div>

//             {/* Form */}
//             <form onSubmit={handleSubmit} className="mb-8">
//                 <div className="flex gap-6 mb-4">
//                     {/* Movie Dropdown */}
//                     <div className="flex flex-col">
//                         <label className="font-semibold mb-1">Movie</label>
//                         <select
//                             name="movieId"
//                             value={form.movieId}
//                             onChange={handleChange}
//                             disabled={!!editing}
//                             required
//                             className="px-4 py-2 border rounded-md"
//                         >
//                             <option value="">-- Select Movie --</option>
//                             {movies.map(movie => (
//                                 <option key={movie._id} value={movie._id}>{movie.name}</option>
//                             ))}
//                         </select>
//                     </div>

//                     {/* Cost Input */}
//                     <div className="flex flex-col">
//                         <label className="font-semibold mb-1">Cost</label>
//                         <input
//                             type="number"
//                             name="cost"
//                             value={form.cost}
//                             onChange={handleChange}
//                             required
//                             className="px-4 py-2 border rounded-md"
//                         />
//                     </div>
//                 </div>

//                 <div className="flex gap-4">
//                     <button type="submit" className="px-6 py-2 bg-blue-600 text-white rounded-md">
//                         {editing ? "Update" : "Add"}
//                     </button>
//                     {editing && (
//                         <button
//                             type="button"
//                             onClick={() => {
//                                 setEditing(null);
//                                 setForm({ movieId: "", cost: "" });
//                             }}
//                             className="px-6 py-2 bg-gray-500 text-white rounded-md"
//                         >
//                             Cancel
//                         </button>
//                     )}
//                 </div>
//             </form>

//             {/* Table */}
//             <h3 className="text-xl font-semibold text-gray-700 mb-4">📃 Purchase Cost Report</h3>
//             <table className="min-w-full border border-gray-300">
//                 <thead className="bg-gray-100">
//                     <tr>
//                         <th className="px-6 py-3 text-left font-semibold">🏛️ Theatre</th>
//                         <th className="px-6 py-3 text-left font-semibold">🎬 Movie</th>
//                         <th className="px-6 py-3 text-left font-semibold">💰 Cost</th>
//                         <th className="px-6 py-3 text-left font-semibold">⚙️ Actions</th>
//                     </tr>
//                 </thead>
//                 <tbody>
//                     {costs.length > 0 ? (
//                         costs.map(({ movieId, theatreId, cost }) => (
//                             <tr key={movieId?._id}>
//                                 <td className="px-6 py-2">{theatreId?.name}</td>
//                                 <td className="px-6 py-2">{movieId?.name}</td>
//                                 <td className="px-6 py-2">{cost}</td>
//                                 <td className="px-6 py-2">
//                                     <button
//                                         onClick={() => handleEdit(movieId?._id, movieId?.name, theatreId?._id, theatreId?.name, cost)}
//                                         className="px-4 py-2 bg-yellow-500 text-white rounded-md"
//                                     >
//                                         Edit
//                                     </button>
//                                     <button
//                                         onClick={() => handleDelete(movieId?._id, theatreId?._id)}
//                                         className="ml-2 px-4 py-2 bg-red-500 text-white rounded-md"
//                                     >
//                                         Delete
//                                     </button>
//                                 </td>
//                             </tr>
//                         ))
//                     ) : (
//                         <tr>
//                             <td colSpan="4" className="px-6 py-4 text-center text-gray-500">
//                                 No purchase costs found for this theatre.
//                             </td>
//                         </tr>
//                     )}
//                 </tbody>
//             </table>
//         </div>
//     );
// };








const PurchaseCost = () => {
    const [form, setForm] = useState({ movieId: "", cost: "" });
    const [editing, setEditing] = useState(null);
    const [costs, setCosts] = useState([]);
    const [theatres, setTheatres] = useState([]);
    const [movies, setMovies] = useState([]);
    const [selectedTheatre, setSelectedTheatre] = useState("");
    const [selectedTheatreId, setSelectedTheatreId] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const { role = "", accessList = [] } = JSON.parse(localStorage.getItem("admin") || "{}");
    const isTicketAdmin = role === "ticket-admin";

    const loadInitialData = async () => {
        setIsLoading(true);
        try {
            const allTheatres = await TheatreServices.getTheatres();
            const filteredTheatres = isTicketAdmin
                ? allTheatres.filter(t => accessList.includes(t.name))
                : allTheatres;

            setTheatres(filteredTheatres);

            if (filteredTheatres.length > 0) {
                const defaultTheatre = filteredTheatres[0];
                setSelectedTheatre(defaultTheatre.name);
                setSelectedTheatreId(defaultTheatre._id);
                await loadMovies(defaultTheatre.name);
            }
        } catch (error) {
            console.error("Error loading theatres:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const loadMovies = async (theatreName) => {
        try {
            const movieList = await MovieServices.getMovies(theatreName);
            setMovies(Array.isArray(movieList) ? movieList : []);
        } catch (error) {
            console.error("Error loading movies:", error);
        }
    };

    const fetchCosts = async () => {
        setIsLoading(true);
        try {
            const res = await PurchaseCostServices.getPurchaseCostsByTheatre(selectedTheatreId);
            setCosts(res.data || []);
        } catch (error) {
            console.error("Error fetching costs:", error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        loadInitialData();
    }, []);

    useEffect(() => {
        if (selectedTheatreId) fetchCosts();
    }, [selectedTheatreId]);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!form.movieId || !form.cost) return;

        const payload = {
            movieId: form.movieId,
            theatreId: selectedTheatreId,
            cost: form.cost,
        };

        setIsLoading(true);
        try {
            let response;
            if (editing) {
                response = await PurchaseCostServices.updatePurchaseCost(
                    editing.movieId,
                    editing.theatreId,
                    { cost: form.cost }
                );
            } else {
                response = await PurchaseCostServices.createPurchaseCost(payload);
            }

            if (response?.error) {
                // toast.error(`⚠️ ${response.error}`);
                alert(`⚠️ ${response.error}`);
            } else {
                // toast.success("✅ Submitted successfully!");
                alert("✅ Submitted successfully!");
                setForm({ movieId: "", cost: "" });
                setEditing(null);
                await fetchCosts();
            }
        } catch (error) {
            console.error("Submit error:", error);
            // toast.error("❌ Submission failed. Please try again.");
            alert("❌ Submission failed. Please try again.");
        } finally {
            setIsLoading(false);
        }
    };

    const handleEdit = (movieId, movieName, theatreId, theatreName, cost) => {
        console.log('movieId, movieName, theatreId, theatreName, cost', movieId, movieName, theatreId, theatreName, cost)

        setForm({ movieId, cost });
        setEditing({ movieId, movieName, theatreId, theatreName, cost });
    };

    const handleDelete = async (movieId, theatreId) => {
        if (!window.confirm("Are you sure you want to delete this cost?")) return;

        setIsLoading(true);
        try {
            await PurchaseCostServices.deletePurchaseCost(movieId, theatreId);
            // toast.success("Cost deleted successfully");
            alert("Cost deleted successfully");
            await fetchCosts();
        } catch (error) {
            console.error("Delete error:", error);
            // toast.error("Failed to delete cost");
            alert("Failed to delete cost");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 p-6">
            <div className="max-w-7xl mx-auto">
                {/* Header */}
                <div className="mb-8 flex justify-between items-center">
                    <div>
                        <h1 className="text-3xl font-bold text-gray-800">
                            {/* <FiBriefcase className="text-3xl text-blue-600" /> */}
                            🎬 Purchase Cost Management</h1>
                        <p className="text-gray-600 mt-2">Manage ticket pricing across theatres and movies</p>
                    </div>
                    <button
                        onClick={fetchCosts}
                        className="flex items-center gap-2 px-4 py-2 bg-white border border-gray-300 rounded-lg shadow-sm hover:bg-gray-50"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-500" viewBox="0 0 20 20" fill="currentColor">
                            <path fillRule="evenodd" d="M4 2a1 1 0 011 1v2.101a7.002 7.002 0 0111.601 2.566 1 1 0 11-1.885.666A5.002 5.002 0 005.999 7H9a1 1 0 010 2H4a1 1 0 01-1-1V3a1 1 0 011-1zm.008 9.057a1 1 0 011.276.61A5.002 5.002 0 0014.001 13H11a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0v-2.101a7.002 7.002 0 01-11.601-2.566 1 1 0 01.61-1.276z" clipRule="evenodd" />
                        </svg>
                        Refresh
                    </button>
                </div>

                {/* Theatre Selection Card */}
                <div className="bg-white rounded-xl shadow-md p-6 mb-8">
                    <h2 className="text-xl font-semibold text-gray-800 mb-4">🏛️ Select Theatre</h2>
                    <div className="flex flex-col sm:flex-row gap-4 items-start sm:items-end">
                        <div className="flex-1 w-full">
                            <label className="block text-sm font-medium text-gray-700 mb-1">Theatre</label>
                            <select
                                value={selectedTheatre}
                                onChange={(e) => {
                                    const selected = theatres.find(t => t.name === e.target.value);
                                    setSelectedTheatre(selected.name);
                                    setSelectedTheatreId(selected._id);
                                    loadMovies(selected.name);
                                    setForm({ movieId: "", cost: "" });
                                    setEditing(null);
                                }}
                                className="mt-1 block w-full pl-3 pr-10 py-3 text-base border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-lg border"
                            >
                                {theatres.map(t => (
                                    <option key={t._id} value={t.name}>{t.name}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                </div>

                {/* Form Card */}

                <div className="bg-white rounded-xl shadow-md p-6 mb-8">
                    <h2 className="text-xl font-semibold text-gray-800 mb-4 flex items-center gap-2">
                        {editing ? (
                            <>
                                <FiEdit className="text-blue-600" />
                                Edit Cost
                            </>
                        ) : (
                            <>
                                <FiFilePlus className="text-green-600" />
                                Add New Cost
                            </>
                        )}
                    </h2>
                    <form onSubmit={handleSubmit}>
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                            {/* Movie Select/Display */}
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Movie</label>
                                {editing ? (
                                    <div className="mt-1 block w-full pl-3 pr-10 py-3 text-base border-gray-300 sm:text-sm rounded-lg border bg-gray-100">
                                        {movies.find(m => m._id === form.movieId)?.name || editing.movieName}
                                    </div>
                                ) : (
                                    <select
                                        name="movieId"
                                        value={form.movieId}
                                        onChange={handleChange}
                                        required
                                        className="mt-1 block w-full pl-3 pr-10 py-3 text-base border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-lg border"
                                    >
                                        <option value="">Select a movie</option>
                                        {movies.map(movie => (
                                            <option key={movie._id} value={movie._id}>{movie.name}</option>
                                        ))}
                                    </select>
                                )}
                            </div>

                            {/* Cost Input */}
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">Cost</label>
                                <div className="relative mt-1 rounded-md shadow-sm">
                                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                        <span className="text-gray-500 text-sm">Rs</span>
                                    </div>
                                    <input
                                        type="number"
                                        name="cost"
                                        value={form.cost}
                                        onChange={handleChange}
                                        required
                                        className="block w-full pl-10 pr-12 py-3 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                                        placeholder="0.00"
                                        min="0"
                                        step="0.01"
                                    />
                                </div>
                            </div>

                            {/* Form Actions */}
                            <div className="flex items-end gap-3">
                                <button
                                    type="submit"
                                    disabled={isLoading}
                                    className="flex-1 inline-flex justify-center items-center py-3 px-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-black hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
                                >
                                    {isLoading ? (
                                        <>
                                            <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                            </svg>
                                            Processing...
                                        </>
                                    ) : editing ? (
                                        "Update Cost"
                                    ) : (
                                        "Add Cost"
                                    )}
                                </button>
                                {editing && (
                                    <button
                                        type="button"
                                        onClick={() => {
                                            setEditing(null);
                                            setForm({ movieId: "", cost: "" });
                                        }}
                                        className="inline-flex justify-center py-3 px-4 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                                    >
                                        Cancel
                                    </button>
                                )}
                            </div>
                        </div>
                    </form>
                </div>

                {/* Costs Table Card */}
                <div className="bg-white rounded-xl shadow-md overflow-hidden">
                    <div className="px-6 py-4 border-b border-gray-200 flex justify-between items-center">
                        <h2 className="text-xl font-semibold text-gray-800">📊 Cost Report</h2>
                        <span className="text-sm text-gray-500">
                            Showing {costs.length} {costs.length === 1 ? "entry" : "entries"}
                        </span>
                    </div>
                    <div className="overflow-x-auto">
                        <table className="min-w-full divide-y divide-gray-200">
                            <thead className="bg-gray-50">
                                <tr>
                                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        Theatre
                                    </th>
                                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        Movie
                                    </th>
                                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        Cost
                                    </th>
                                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                        Actions
                                    </th>
                                </tr>
                            </thead>
                            <tbody className="bg-white divide-y divide-gray-200">
                                {isLoading ? (
                                    <tr>
                                        <td colSpan="4" className="px-6 py-8 text-center">
                                            <div className="flex justify-center">
                                                <svg className="animate-spin h-8 w-8 text-blue-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                                </svg>
                                            </div>
                                        </td>
                                    </tr>
                                ) : costs.length > 0 ? (
                                    costs.map(({ movieId, theatreId, cost }) => (
                                        <tr key={`${movieId?._id}-${theatreId?._id}`} className="hover:bg-gray-50">
                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <div className="flex items-center">
                                                    <div className="flex-shrink-0 h-10 w-10 bg-blue-100 rounded-full flex items-center justify-center">
                                                        <svg className="h-6 w-6 text-blue-600" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                                            <path fillRule="evenodd" d="M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm3 2h6v4H7V5zm8 8v2h1v-2h-1zm-2-8h1V5h-1v2zm2 4h1V9h-1v2zm0 4h1v-2h-1v2zm-4 0h1v-2h-1v2zm-4 0h1v-2H7v2zm-1-4h1V9H6v2zm0-4h1V5H6v2zm-1 8h1v-2H5v2z" clipRule="evenodd" />
                                                        </svg>
                                                    </div>
                                                    <div className="ml-4">
                                                        <div className="text-sm font-medium text-gray-900">{theatreId?.name}</div>
                                                    </div>
                                                </div>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <div className="text-sm font-medium text-gray-900">{movieId?.name}</div>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <div className="text-sm font-semibold text-blue-600">Rs.{parseFloat(cost).toFixed(2)}</div>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                                                <div className="flex space-x-2">
                                                    <button
                                                        onClick={() => handleEdit(movieId?._id, movieId?.name, theatreId?._id, theatreId?.name, cost)}
                                                        className="inline-flex items-center px-3 py-1 border border-yellow-500 rounded-md shadow-sm text-sm font-medium text-yellow-700 bg-yellow-100 hover:bg-yellow-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500"
                                                    >
                                                        <svg className="-ml-1 mr-1 h-4 w-4" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
                                                        </svg>
                                                        Edit
                                                    </button>
                                                    <button
                                                        onClick={() => handleDelete(movieId?._id, theatreId?._id)}
                                                        className="inline-flex items-center px-3 py-1 border border-red-500 rounded-md shadow-sm text-sm font-medium text-red-700 bg-red-100 hover:bg-red-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                                                    >
                                                        <svg className="-ml-1 mr-1 h-4 w-4" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                                            <path fillRule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clipRule="evenodd" />
                                                        </svg>
                                                        Delete
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="4" className="px-6 py-8 text-center text-gray-500">
                                            <div className="flex flex-col items-center justify-center">
                                                <svg className="h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                                </svg>
                                                <p className="mt-2 text-sm font-medium">No purchase costs found</p>
                                                <p className="text-xs">Try selecting a different theatre or add new costs</p>
                                            </div>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>




            </div>
        </div>
    );
};


export default PurchaseCost;

